export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-5 bg-primary-100 rounded-2xl flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-5">关于皮皮漫画</h2>
            <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70 text-left">
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                皮皮漫画是一个专注于在线漫画阅读的综合平台，致力于为漫画爱好者提供最优质的阅读体验。
                平台收录了皮皮漫画韩漫、皮皮漫画日漫、皮皮漫画国漫等超过12,000部漫画作品，
                涵盖少年热血、少女恋爱、古风仙侠、都市言情、悬疑推理、科幻未来等数十种类型。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                我们坚持每日更新，确保读者能够第一时间阅读到最新话内容。皮皮漫画的专业汉化团队
                对每一部引进作品进行精心翻译和校对，力求为读者呈现原汁原味的精彩故事。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                皮皮漫画始终秉承「让好漫画触手可及」的理念，无论是韩漫的细腻情感、日漫的热血冒险，
                还是国漫的东方韵味，你都能在这里找到属于自己的精彩世界。我们持续优化阅读体验，
                用心打造每一个细节，期待成为你最信赖的漫画阅读伙伴。
              </p>
            </div>
            <div className="flex flex-wrap justify-center gap-6 mt-8">
              <div className="text-center">
                <div className="text-2xl font-heading text-primary-500">5年</div>
                <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading text-accent-500">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">服务可用率</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading text-secondary-500">380万+</div>
                <div className="text-xs text-foreground-500 mt-1">忠实读者</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}